import { lazy } from 'react';

import { PageSuspense } from 'src/components';


const AccountProductFullUpdatePage = lazy(() => import('../views/update/AccountProductFullUpdatePage'));

export function AccountProductFullUpdatePageLazy() {
	return (
		<PageSuspense>
			<AccountProductFullUpdatePage />
		</PageSuspense>
	);
}
